import React, { useState, useRef, useEffect } from 'react';
import Form from 'react-bootstrap/Form';

import './BooleanQueryCreate.css';
import DropdownQueryLabel from '../../../container/dropdown/dropdown-query-create/DropdownQueryLabel';
import TooltipWithTimer from '../../tooltip/TooltipWithTimer';

const BooleanQueryCreate = (props) => {
  const [tooltipShow, setTooltipShow] = useState(false);
  const tooltipTarget = useRef(null);

  const booleanQueryPlaceholder = "모든 단어 포함(AND): &\n적어도 한 단어를 포함(OR): |\n다음 단어들 없이(NOT): !\n일부 특수문자 사용 제한: {, }, [, ], ...";

  useEffect(() => {
    const timerId = setInterval(() => {
      if(tooltipShow) setTooltipShow(false);
    }, 3000);
    return () => clearInterval(timerId);
  }, [tooltipShow]);

  const handleResultBtn = () => {
    const body = {
      "query" :{
        "boolQuery": props.booleanQuery
      },
      "type": "BOOLEAN",
      "dateRange" : [props.dateRange[0].toLocaleDateString("ja-JP",{year:"numeric", day:"2-digit", month:"2-digit"}), props.dateRange[1].toLocaleDateString("ja-JP",{year:"numeric", day:"2-digit", month:"2-digit"})]
    }

    return props.handleResultBtn("/search/query-content", body, props.resultData);
  }

  return (
    <>
      <div className="queryBoxBg">
        <div className="queryBoxTit">Boolean</div>
          <Form>
            <Form.Group>
              <Form.Control as="textarea" placeholder={booleanQueryPlaceholder} value={props.booleanQuery} onChange={props.handleBooleanQuery}
                name="textarea" rows={13} id="queryInput" />
            </Form.Group>
          </Form>
      </div>
      <div className="queryBox50Btn">
        <a className="button purple" onClick={()=>{handleResultBtn()}}>결과 확인</a>
        &nbsp;
        {/* <TooltipOnlyTextWithTimer tooltipDirection="top" tooltipText="검색어가 저장되었습니다.">
          <a className="button blueLine" onClick={()=>props.handleSaveBtn('booleanQuery')}>검색어 저장</a>
      </TooltipOnlyTextWithTimer> */}
      <DropdownQueryLabel toggle="검색어 저장" handleSaveBtn={(query, label, labelID)=>props.handleSaveBtn('booleanQuery',query, label, labelID)} tooltipRef={tooltipTarget} handleTooltip={(bool)=>setTooltipShow(bool)} userLabelData={props.userLabelData}/>
        <TooltipWithTimer target={tooltipTarget} show={tooltipShow}
          tooltipDirection="top" tooltipText={props.saveTooltip} />
      </div>
    </>
  )
}

export default BooleanQueryCreate;  